export default __webpack_public_path__ + "static/media/SM_logo_white.65ae5167.svg";